module.exports = __webpack_public_path__ + "img/main-spring_m.d811fcfe.jpg";